// extracted by mini-css-extract-plugin
export default {"menu":"ARCT8","menuCollapsed":"HSvQ5","avatar":"bmjOQ","inner":"cb4q_","text":"VwZJW","icon":"NnLDc"};